import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetVehicleBrochureRequest,
  GetVehicleBrochureResponse
} from "./interfaces/get-vehicle-brochure";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getVehicleBrochure(
  data: GetVehicleBrochureRequest,
  env: Environment
): Promise<GetVehicleBrochureResponse> {
  const url = `${getBaseUrl(env)}cxm/vehicle-brochure`;
  const header = await getHeader();
  const queryParams = new URLSearchParams({
    consumerId: data.consumerId,
    consumerRecordSystem: data.consumerRecordSystem,
    autoLeadId: data.autoLeadId.toString(),
    vinDealerId: data.vinDealerId.toString()
  });

  try {
    const response = await fetchWrapper.getAsync<GetVehicleBrochureResponse>(
      `${url}?${queryParams.toString()}`,
      header
    );

    if (response && response.data && !response.hasError) {
      return response.data;
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `Error fetching vehicle brochure for autoLeadId: ${data.autoLeadId}`,
        response?.error
      );
      return {
        errorType: response?.statusCode === 404 ? "not_found" : "generic"
      };
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      `Exception fetching vehicle brochure for autoLeadId: ${data.autoLeadId}`,
      error
    );
    return { errorType: "generic" };
  }
}
